import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Container } from "@/components/layout/Container";
import { QuoteConfigurator } from "@/components/quote/QuoteConfigurator";
import stratoLogo from "@/assets/brand/strato-logo.png";

export default function Preventivo() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-strato-offwhite">
      {/* Minimal configurator header */}
      <header className="sticky top-0 z-40 border-b border-strato-gray-100 bg-strato-offwhite/85 backdrop-blur-md">
        <Container className="flex h-16 items-center justify-between">
          <Link
            to="/"
            data-testid="quote-header-wordmark"
            className="flex items-center gap-2"
          >
            <img
              src={stratoLogo}
              alt="Strato Lab 3D"
              className="h-7 w-7 rounded-md object-contain"
            />
            <span className="font-display text-[15px] font-semibold tracking-[-0.01em] text-strato-graphite">
              Strato Lab 3D
            </span>
          </Link>
          <Link
            to="/"
            data-testid="quote-back-home"
            className="text-sm font-medium text-strato-graphite/70 transition-colors hover:text-strato-graphite"
          >
            Chiudi
          </Link>
        </Container>
      </header>

      <main className="py-12 lg:py-16">
        <Container>
          <QuoteConfigurator />
        </Container>
      </main>
    </div>
  );
}
